import { AbstractLocalStorageService } from './abstractLocalStorageService';

class LanguageLocalStorageService extends AbstractLocalStorageService {
  private LANGUAGE_LOCAL_STORAGE_KEY: string = 'language';

  public setLanguage(language: string): void {
    this.setItem(this.LANGUAGE_LOCAL_STORAGE_KEY, language);
  }

  public getLanguage(): string {
    return this.getItem(this.LANGUAGE_LOCAL_STORAGE_KEY) ?? 'hu';
  }
}

export const languageLocalStorageService = new LanguageLocalStorageService();
